import { darken, getLuminance, toHex, lighten } from 'color2k';

export const getDarken = (
	color: string,
	amount = 0.4,
	minLuminance = 0.002,
) => {
	const newColor = toHex(darken(color, amount));

	if (getLuminance(newColor) < minLuminance) {
		return getDarken(color, amount - 0.001);
	}

	return newColor;
};

export const getLighten = (
	color: string,
	amount = 0.8,
	maxLuminance = 0.75,
) => {
	const newColor = toHex(lighten(color, amount));

	if (getLuminance(newColor) > maxLuminance) {
		return getLighten(color, amount - 0.001);
	}

	return newColor;
};
